const defaultApiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export const config = {
  BASE_URL: defaultApiUrl,
  LABELER_API_URL: process.env.REACT_APP_LABELER_API_URL || defaultApiUrl,
  ATLAS_URL: process.env.REACT_APP_ATLAS_URL || 'http://127.0.0.1:3001',
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  LABELER_URL: process.env.REACT_APP_LABELER_URL,
};
